import { Component, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { TranslocoPipe } from '@jsverse/transloco';
import { PolicyType } from '@htx/policies';
import { CONSTRAINT_CATEGORIES } from '../../shared/constraint-metadata';

@Component({
  selector: 'app-constraint-picker',
  imports: [MatMenuModule, MatIcon, MatButton, MatIconButton, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './constraint-picker.component.html',
  styleUrl: './constraint-picker.component.scss'
})
export class ConstraintPickerComponent {
  /** PolicyTypes that are already added and should be disabled. */
  readonly disabledTypes = input<PolicyType[]>([]);

  /** Emits the selected PolicyType when user clicks a menu item. */
  readonly typeSelected = output<PolicyType>();

  /** Whether to show a compact icon-only trigger button. */
  readonly compact = input(false);

  readonly categories = CONSTRAINT_CATEGORIES;

  readonly hasAvailableTypes = computed(() => {
    const disabled = new Set(this.disabledTypes());
    return CONSTRAINT_CATEGORIES.some(cat =>
      cat.types.some(t => !disabled.has(t.type))
    );
  });

  isDisabled(type: PolicyType): boolean {
    return this.disabledTypes().includes(type);
  }

  select(type: PolicyType): void {
    if (!this.isDisabled(type)) {
      this.typeSelected.emit(type);
    }
  }
}
